import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arbitration-department',
  templateUrl: './arbitration-department.component.html',
  styleUrls: ['./arbitration-department.component.scss']
})
export class ArbitrationDepartmentComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
